<ng-template #page><ng-content /></ng-template>

@if (chrome()) {
  <p-sidebar-layout>
    <!-- Прокручивается окно (отчёты слушают scrollWindow, sticky-шапки таблиц — top:0 окна), поэтому меню держится
         в видимой области обёрткой sticky высотой с окно; p-sidebar растягивается в ней (flex) и задаёт ширину. -->
    <div class="sticky top-0 flex h-svh shrink-0 self-start">
      <p-sidebar id="cp-navigation" collapsible="icon" width="16rem" [(open)]="expanded">
        <p-sidebar-spacer />
        <p-sidebar-aside>
          <p-sidebar-panel>
            <p-sidebar-header>
              <div class="flex h-12 items-center gap-3">
                <img src="assets/images/pt-mark.svg" alt="Paratype" class="size-9 shrink-0" />
                @if (expanded()) {
                  <div class="min-w-0">
                    <div class="font-semibold leading-5">Paratype</div>
                    <div class="text-xs leading-4 text-muted-color">Control Panel</div>
                  </div>
                }
              </div>
              <!-- Глобальный поиск макета: бэкенда нет — обёртка скрыта до отдельной задачи (Layout.md, data-cp-planned). -->
              <div data-cp-planned="true" hidden>
                @if (expanded()) {
                  <p-iconfield>
                    <p-inputicon class="pi pi-search" />
                    <input pInputText pSize="small" [fluid]="true" readonly placeholder="Search" aria-label="Search" aria-keyshortcuts="/" />
                  </p-iconfield>
                } @else {
                  <button pButton type="button" severity="secondary" [outlined]="true" size="small" iconOnly aria-label="Search (press /)"><i class="pi pi-search" aria-hidden="true"></i></button>
                }
              </div>
            </p-sidebar-header>
            <p-sidebar-content>
              @for (entry of navigation(); track entry.label) {
                <p-sidebar-group>
                  @if (entry.items) {
                    <p-sidebar-group-label>{{ entry.label | uppercase }}</p-sidebar-group-label>
                  }
                  <p-sidebar-group-content>
                    <p-sidebar-menu>
                      @for (item of entry.items ?? [entry]; track item.label) {
                        <p-sidebar-menu-item>
                          <!-- Ссылка, а не кнопка макета: пункт — переход (новая вкладка, адрес в строке состояния).
                               no-underline снимает подчёркивание ссылки из стилей браузера (preflight не подключён),
                               не правило PrimeNG: у p-sidebar-menu-button text-decoration не задан.
                               В свёрнутом меню подпись пункта — pTooltip справа (у p-sidebar штатной подсказки нет),
                               без title: браузерная подсказка дублировала бы его (PAR-12964). -->
                          <a pSidebarMenuButton
                             class="no-underline"
                             [routerLink]="item.routerLink"
                             routerLinkActive
                             ariaCurrentWhenActive="page"
                             #link="routerLinkActive"
                             [isActive]="link.isActive"
                             [pTooltip]="item.label"
                             tooltipPosition="right"
                             [tooltipDisabled]="expanded()"
                             [attr.aria-label]="expanded() ? null : item.label">
                            <i [class]="item.icon" aria-hidden="true"></i><span>{{ item.label }}</span>
                          </a>
                        </p-sidebar-menu-item>
                      }
                    </p-sidebar-menu>
                  </p-sidebar-group-content>
                </p-sidebar-group>
              }
            </p-sidebar-content>
            <p-sidebar-footer>
              @if (expanded()) {
                <div class="flex items-center gap-2">
                  <p-avatar [label]="initial()" shape="circle" class="shrink-0" />
                  <div class="min-w-0 flex-1">
                    <div class="truncate font-medium leading-5" data-cp-truncate [attr.title]="email()">{{ email() }}</div>
                    @if (role(); as role) {
                      <div class="truncate text-xs leading-4 text-muted-color">{{ role }}</div>
                    }
                  </div>
                  <button pButton type="button" [text]="true" severity="secondary" size="small" iconOnly aria-label="User menu"
                          aria-haspopup="menu" [attr.aria-expanded]="userMenuOpen()"
                          (click)="userMenuPopup.toggle($event)"><i class="pi pi-ellipsis-v" aria-hidden="true"></i></button>
                </div>
              } @else {
                <!-- Свёрнутое меню: аватар — кнопка того же меню пользователя (Log out), PAR-12964. -->
                <div class="flex justify-center">
                  <button pButton type="button" [text]="true" [rounded]="true" severity="secondary" iconOnly aria-label="User menu"
                          aria-haspopup="menu" [attr.aria-expanded]="userMenuOpen()"
                          (click)="userMenuPopup.toggle($event)"><p-avatar [label]="initial()" shape="circle" /></button>
                </div>
              }
            </p-sidebar-footer>
          </p-sidebar-panel>
        </p-sidebar-aside>
      </p-sidebar>
    </div>
    <p-sidebar-main class="min-w-0">
      @if (versionCheck.updateAvailable()) {
        <!-- PAR-12788: страница сама не перезагружается — в форме могут быть несохранённые данные. -->
        <div class="border-b border-surface bg-surface-0 px-6 py-2">
          <p-message severity="info" size="small" class="block">
            <div class="flex items-center gap-4">
              <span>A new version is available</span>
              <button pButton type="button" size="small" (click)="versionCheck.reload()">Reload</button>
            </div>
          </p-message>
        </div>
      }
      <header class="flex h-16 shrink-0 items-center gap-4 border-b border-surface bg-surface-0 px-6">
        <div class="flex min-w-0 items-center gap-3">
          <!-- Триггер вне p-sidebar: без target он ищет sidebar среди предков и ничего не делает. -->
          <button pButton pSidebarTrigger target="cp-navigation" type="button" [text]="true" severity="secondary" size="small" iconOnly
                  aria-label="Toggle sidebar" [attr.aria-expanded]="expanded()"><i class="pi pi-bars" aria-hidden="true"></i></button>
          <p-breadcrumb class="-ml-3 min-w-0" [model]="crumbs()" [home]="home">
            <ng-template #item let-item>
              @if (item.routerLink && item.icon) {
                <!-- Шаблон #item у p-breadcrumb рисует и home: ссылка — разметка самого Breadcrumb (классы его частей), без своих утилит. -->
                <a [routerLink]="item.routerLink" class="p-breadcrumb-item-link" aria-label="Home"><span [class]="'p-breadcrumb-item-icon ' + item.icon" aria-hidden="true"></span></a>
              } @else if (item.routerLink) {
                <!-- Уровень-ссылка назад (пункт меню или уровень страницы, BreadcrumbTrail) — разметка самого Breadcrumb. -->
                <a [routerLink]="item.routerLink" class="p-breadcrumb-item-link"><span class="p-breadcrumb-item-label">{{ item.label }}</span></a>
              } @else if (item.state?.current) {
                <span class="font-medium" aria-current="page">{{ item.label }}</span>
              } @else {
                <span class="text-muted-color">{{ item.label }}</span>
              }
            </ng-template>
          </p-breadcrumb>
        </div>
      </header>
      <div class="min-w-0 flex-1 bg-surface-0">
        <ng-container [ngTemplateOutlet]="page" />
      </div>
    </p-sidebar-main>
  </p-sidebar-layout>
  <!-- Вне панели меню: у p-sidebar-panel overflow:hidden, оверлей уходит в body. -->
  <!-- aria-expanded кнопки — по событиям попапа: меню закрывается и кликом вне него, и Escape, и выбором пункта — мимо кнопки. -->
  <p-menu #userMenuPopup [model]="userMenu" [popup]="true" appendTo="body"
          (onShow)="userMenuOpen.set(true)" (onHide)="userMenuOpen.set(false)" />
  <!-- Кнопка «наверх» для всех страниц: прокрутка у окна (target по умолчанию — window), появляется после порога PrimeNG. -->
  <p-scrolltop behavior="smooth" />
} @else {
  <ng-container [ngTemplateOutlet]="page" />
}
